import {DataSource} from "./admin/data/DataSource";
import {Participant} from "./model/Participant";
import {Section} from "./model/Section";
import {Course} from "./model/Course";

export const frontendParticipantDS = new DataSource<Participant>("elearning/frontend/participants/", "*,customFields,attempts,user[*],licenses[*,course[*,blocks[block]]]," +
	"sections[id,name,licenses[*,course]],missingDocumentTypes[*,documentType[*,id,name]]," +
	"documents[id,documentTypeId,blobId,identification,documentDate,expiryDate,documentBlob[name,contentType]," +
	"documentType[name]],missingDocumentTypes[documentTypeId],tokenLicense");

export const frontendSectionDS = new DataSource<Section>("elearning/frontend/sections", "*,languages[*,language]");

export const frontendCourseDS = new DataSource<Course>("elearning/frontend/courses", "*,languages[*,language], blocks[*,block[*,languages[*,content,language]]],sections[*]");